import styled from 'styled-components';

const YTVideoItemHolder = styled.div`
	.yt-video-item {
		cursor: pointer;
	}
	.yt-video-description {
		text-align: left;
		font-size: 17px;
		color: #383838;
		font-family: "Quicksand", sans-serif;
		font-weight: 500;
		line-height: 1.6em;
	}
`;

export default YTVideoItemHolder;